import { Input } from 'antd'
import { useState, useEffect } from 'react'


EditableMultiLine = ({ valueKey, node }) ->

  [loading, setLoading] = useState(true)
  [value, setValue] = useState('')

  useEffect( ->
    setLoading(true)
    setValue(node.get(valueKey))
    setLoading(false)
    undefined
  , [node])

  <div>
    <Input.TextArea
      disabled={loading}
      autosize={minRows: 4, maxRows: 10}
      type="text"
      value={value}
      onChange={(e) -> setValue(e.target.value)}
      onBlur={() -> save()}
    />
  </div>

export default EditableMultiLine
